var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledDiaryStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_4800_41644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6667 91.2044C74.6785 91.2044 93.3333 72.5496 93.3333 49.5378C93.3333 26.5259 74.6785 7.87109 51.6667 7.87109C28.6548 7.87109 10 26.5259 10 49.5378C10 72.5496 28.6548 91.2044 51.6667 91.2044ZM38.808 68.5721C40.2141 70.2433 42.1679 71.2044 44.1766 71.2044C46.1785 71.2023 48.1301 70.2386 49.5291 68.5693L73.3806 40.1484C75.1121 38.082 75.0925 34.7561 73.338 32.7191C71.5781 30.6799 68.7497 30.7028 67.0147 32.7692L44.1658 59.9974L34.3158 48.263C32.5862 46.1988 29.7543 46.1781 27.996 48.2148C26.2396 50.2497 26.2219 53.5758 27.9534 55.6418L38.808 68.5721Z",
    fill: "url(#paint0_linear_4800_41644)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_4800_41644",
    x: 10,
    y: 2.26902,
    width: 83.333,
    height: 94.5374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5.60207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.80104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0877177 0 0 0 0 1 0 0 0 0 0.707224 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4800_41644"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.60207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.80104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0315294 0 0 0 0 0.364559 0 0 0 0 0.254206 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4800_41644",
    result: "effect2_innerShadow_4800_41644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4800_41644",
    x1: 51.6667,
    y1: 7.87109,
    x2: 51.6667,
    y2: 91.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15F0A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDiaryStatus);
export default __webpack_public_path__ + "static/media/FilledDiaryStatus.41fdcc7511ec5d85752b6aa9c2df2e61.svg";
export { ForwardRef as ReactComponent };